import {CreditText} from "../models/CreditText";
import {makeAutoObservable} from "mobx";
import agent from "../api/agent";
import {defaultSetting, Setting} from "../models/Setting";

export default class SettingsStore {
    settings: Setting[] = [];
    isLoading = false;

    constructor() {
        makeAutoObservable(this);
        this.findAll();
    }

    findAll = async () => {
        this.setIsLoading(true);
        const settings: Setting[] = await agent.Settings.findAll();
        if(settings) this.setSettings(settings);
        this.setIsLoading(false);
    }
    
    findByName =  (name: string): Setting => {
        const setting = this.settings.find(s => s.name.toLowerCase() === name.toLowerCase());
        if(setting) return setting;
        return defaultSetting();
    }

    update = async (setting: Setting) => {
        this.setIsLoading(true);
        const updated = await agent.Settings.update(setting);
        if(updated) this.settings = this.settings.map(s => s.id === updated.id ? updated : s)
        this.setIsLoading( false);
    }

    setIsLoading = (isLoading: boolean) => { this.isLoading = isLoading; }
    
    setSettings = (settings: Setting[]) => { this.settings = settings }
}